import request from '@/utils/request'


export function activeworks(params) {
    return request({
        url: '/staffs/activeworks',
        method: 'get',
        params: params
    })
}

